import { Injectable } from '@angular/core';
import { generateUUID } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private sessionKey: string = 'splitzero.session.uuid';

  constructor() {
    this.initSession();
  }

  getUuid(): string {
    return sessionStorage.getItem(this.sessionKey) || '';
  }

  private initSession(): void {
    if (!sessionStorage.getItem(this.sessionKey)) {
      const sessionId: string = generateUUID();

      sessionStorage.setItem(this.sessionKey, sessionId);
    }
  }
}
